import {UnLitElement} from "../../common/elements";
import {customElement, property, state} from "lit/decorators.js";
import {html, type TemplateResult} from "lit";
import {unsafeHTML} from "lit/directives/unsafe-html.js";
import {Role} from "./gptChatApp";
import {eopCustomEvent} from "../../common/utils/events";
import {Dictionary} from "../../page/elements/dictionary";

export const CAREER_GPT_MESSAGE_RATING_EVENT = "career-gpt-message-rating";

export type CareerGptMessageRatingEvent = CustomEvent<CareerGptMessageRatingEventData>;

export type CareerGptMessageRatingEventData = {
    ratingPositive: boolean;
};

@customElement("eop-career-gpt-message")
export class CareerGptMessage extends UnLitElement {
    @property({attribute: "message", type: String})
    public message: string;
    @property({attribute: "role", reflect: true, type: Role})
    public role: Role;
    @property({attribute: "with-rating", type: Boolean})
    public withRating: boolean = false;

    @state()
    private ratingPositive: boolean | undefined;

    private dictionary: Dictionary;

    public connectedCallback(): void {
        super.connectedCallback();

        this.dictionary = Dictionary.of(this);
    }

    public render(): TemplateResult {
        return html`
            <div class="chat-message">
                <div class="chat-message-content">${unsafeHTML(this.message)}</div>
            </div>
            ${this.renderRating()}
        `;
    }

    private renderRating(): TemplateResult | undefined {
        if (!this.withRating || this.role !== Role.ASSISTANT) {
            return undefined;
        }

        const ratingLocked = this.ratingPositive !== undefined;
        const ratingWasPositive = this.ratingPositive === true;
        const ratingWasNegative = this.ratingPositive === false;
        return html`
            <div class="chat-message-rating">
                <button type="button"
                        class="thumbs-up"
                        ?selected=${ratingWasPositive}
                        ?disabled=${ratingLocked}
                        aria-label=${this.dictionary.translate("MSG_THUMBS_UP_LABEL")}
                        aria-pressed=${ratingWasPositive}
                        @click=${() => this.rateResponse(true)}
                ><eop-svg-sprite-icon icon-id="thumbs_up"></eop-svg-sprite-icon></button>
                <button type="button"
                        class="thumbs-down"
                        ?selected=${ratingWasNegative}
                        ?disabled=${ratingLocked}
                        aria-label=${this.dictionary.translate("MSG_THUMBS_DOWN_LABEL")}
                        aria-pressed=${ratingWasNegative}
                        @click=${() => this.rateResponse(false)}
                ><eop-svg-sprite-icon icon-id="thumbs_down"></eop-svg-sprite-icon></button>
            </div>
        `;
    }

    private rateResponse(ratingPositive: boolean): void {
        if (this.ratingPositive !== undefined) {
            return;
        }

        this.ratingPositive = ratingPositive;
        this.dispatchEvent(eopCustomEvent(CAREER_GPT_MESSAGE_RATING_EVENT, {ratingPositive}));
    }
}